import React from "react";

export class FullscreenToggle extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state =
            {
                "fullscreen":false
            }
        this.toggleClicked = this.toggleClicked.bind(this);
    }

    toggleClicked()
    {
        if (this.state.fullscreen)
        {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { /* Safari */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE11 */
                document.msExitFullscreen();
            }

            this.setState({fullscreen:false});
        }
        else
        {
           let elem = document.documentElement;
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) { /* Safari */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE11 */
                elem.msRequestFullscreen();
            }

            this.setState({fullscreen:true});
        }


    }

    render()
    {
        return (
            <>
                {!this.state.fullscreen && (
                    <img src="/digibord/assets/svgs/ui/full-screen.svg" className="fullscreen_btn" onClick={this.toggleClicked} />
                )}
                {this.state.fullscreen && (
                    <img src="/digibord/assets/svgs/ui/exit-full-screen.svg" className="fullscreen_btn" onClick={this.toggleClicked} />
                )}
            </>
        )
    }
}
